// extracted by mini-css-extract-plugin
module.exports = {"AnswerItem":"AnswerItem__AnswerItem___3SNQ0","success":"AnswerItem__success___ISZ70","error":"AnswerItem__error___1EAN0"};